"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@chakra-ui/react");

var _RendererContext = require("../RendererContext");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

/**
 * @param {{
 * block: BlockButton
 * }} param0
 */
var BlockButtonChakra = function BlockButtonChakra(_ref) {
  var _block$content$intl$l, _block$content$intl$l2, _block$content$intl$d, _block$content$intl$l3, _block$content$intl$l4, _block$content$intl$d2;

  var block = _ref.block;

  var _useContext = (0, _react.useContext)(_RendererContext.RendererContext),
      document = _useContext.document,
      language = _useContext.language;

  var text = (_block$content$intl$l = (_block$content$intl$l2 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l2.text) != null ? _block$content$intl$l : (_block$content$intl$d = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d.text;
  var url = (_block$content$intl$l3 = (_block$content$intl$l4 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l4.url) != null ? _block$content$intl$l3 : (_block$content$intl$d2 = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d2.url;
  return __jsx(_react2.Button, {
    as: "a",
    cursor: "pointer",
    href: url,
    width: "100%",
    height: "auto",
    paddingTop: "".concat(block.content.paddingTop, "px"),
    paddingRight: "".concat(block.content.paddingRight, "px"),
    paddingBottom: "".concat(block.content.paddingBottom, "px"),
    paddingLeft: "".concat(block.content.paddingLeft, "px"),
    backgroundColor: block.content.backgroundColor,
    _hover: {
      backgroundColor: block.content.backgroundColor
    },
    borderRadius: "".concat(block.content.borderRadius, "px"),
    borderWidth: "".concat(block.content.borderWidth, "px"),
    borderColor: block.content.borderColor,
    color: block.content.color,
    target: block.content.openInNewTab ? "blank" : "_self"
  }, text);
};

BlockButtonChakra.displayName = "BlockButtonChakra";
var _default = BlockButtonChakra;
exports["default"] = _default;